import React, { useEffect } from 'react';
import { useDencrypt } from 'use-dencrypt-effect';

const decryptOptions = {
  chars: [...'-./*!?#%&@$€()[]{}<>~0123456789abcdefghijklmnopqrstuvwxyz'],
  interval: 50,
};

export const TextDecrypt = ({ text = '' }) => {
  const { result, dencrypt } = useDencrypt(decryptOptions);

  useEffect(() => {
    const timer = setTimeout(() => dencrypt(text), 0);
    return () => clearTimeout(timer);
  }, [dencrypt, text]);

  return <>{result}&nbsp;</>;
};